/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import {
  revisarCaja,
  salirRevisarCaja,
  cerrarCaja
} from "../../../project/services/CajaService";
import { useNavigate } from "react-router-dom";
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import settings from "../../../configs/settings";
import Message from "../../../project/utils/Message";
import DialogContentText from '@mui/material/DialogContentText';
import WaitingDialog from "../../utils/WaitingDialog";

const nameItemsText = "Caja";
//
// #############################################################################
//
const CajaCierreDialog = ({ onClose, idCaja, setIniciar, codigoCaja }) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [cobranzas, setCobranzas] = useState([])
  const [ajustes, setAjustes] = useState([])
  const [comprobantes, setComprobantes] = useState([])
  const [control, setControl] = useState({})
  const navigate = useNavigate();
  const [openDialogCerrar, setOpenDialogCerrar] = useState(false)
  const [nonClose, setNonClose] = useState(false)

  const tableCobranzasColumns = [
    {
      field: "tipo_cobro",
      headerName: "Tipo de Cobro",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = "";
        switch (params.row.tipo_cobro) {
          case "efectivo":
            _val = "EFECTIVO";
            break;
          case "tarjeta-debito":
            _val = "TARJETA DE DÉBITO";
            break;

          case "tarjeta-credito":
            _val = "TARJETA DE CRÉDITO";
            break;

          case "billetera-virtual":
            _val = "BILLETERA VIRTUAL";
            break;

          case "obra-social":
            _val = "OBRA SOCIAL";
            break;

          case "descuento-especial":
            _val = "DESCUENTO ESPECIAL";
            break;

          case "otro":
            _val = "OTRO";
            break;

          case "transferencia-bancaria":
            _val = "TRANSFERENCIA BANCARIA";
            break;

          case "cheque":
            _val = "CHEQUE";
            break;
        }
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "importe",
      headerName: "Importe Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableAjustesColumns = [
    {
      field: "descripcion",
      headerName: "Tipo de Ajuste",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = ' ( ' + (params.row.suma_resta === 'suma' ? '+' : '-') + ' )' + '  ' + (params.row.descripcion)
        return _val
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad de ajustes",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "importe",
      headerName: "Importe Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableComprobantesColumns = [
    {
      field: "descripcion",
      headerName: "Tipo de Comprobante de gastos",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad de comprobantes",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "importe",
      headerName: "Importe Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {

    const load = async () => {

      setIsDoingSomething(true);
      const response = await revisarCaja(idCaja);
      setIsDoingSomething(false);

      if (response.ok) {

        console.log('------------------------------');
        console.log('im in ');
        console.log('response.data.data');
        console.log(response.data.data);
        console.log('------------------------------');

        setNonClose(response.data.data.non_close)
        setCobranzas(response.data.data.cobranza)
        setAjustes(response.data.data.tipo_ajuste)
        setComprobantes(response.data.data.tipo_comprobante)
        setControl(response.data.data)
      }
    }
    load();
  }, []);
  //
  // ################################################################################
  //
  const handleSalirRevisarCaja = async () => {

    setIsDoingSomething(true);
    const response = await salirRevisarCaja(idCaja);
    setIsDoingSomething(false);

    if (response.ok) {
      navigate("/cajas-table");
    }
    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
    onClose();
  }
  //
  // ################################################################################
  //
  const handleCerrarCaja = async () => {
    // utilizar primero la confirmacion de cierra de caja
    setOpenDialogCerrar(true)
    if (!openDialogCerrar) {
      return
    }
    setIsDoingSomething(true);
    const response = await cerrarCaja(idCaja);
    setIsDoingSomething(false);

    if (response.ok) {
      navigate("/cajas-table");
      setIniciar(true)
    }
    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
    onClose();
  }
  //
  // ################################################################################
  //
  const handleCloseDialogCerrar = (value) => {
    if (value) {
      handleCerrarCaja()
    }
    setOpenDialogCerrar(false)
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleSalirRevisarCaja}
        maxWidth="lg"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Revisión de Caja
          <IconButton
            aria-label="close"
            onClick={handleSalirRevisarCaja}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between" alignItems="center" >
                <Typography variant="h5" display="block" gutterBottom>
                  {nameItemsText} {codigoCaja}
                </Typography>

                <Box display="flex" alignItems="center">
                  <Typography variant="h6" display="block" gutterBottom sx={{ mr: 4, color: '#1976d2' }}>
                    REVISION
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* table de Cobranzas */}

          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6" display="block" gutterBottom sx={{ mr: 4 }}>
              Cobranzas
            </Typography>
          </Grid>

          <DataGrid
            rows={cobranzas}
            columns={tableCobranzasColumns}
            {...tableOptions}
          />

          <Box sx={{ display: 'flex', alignItems: "center", ml: 3, mb: 3 }}>
            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, mt: 2 }}>
              Total Efectivo
            </Typography>
            <TextField
              name="totalEfectivo"
              size="small"
              inputProps={{ style: { textAlign: "right" } }}
              variant="outlined"
              value={cobranzas.reduce((acc, item) => acc + (item.tipo_cobro === 'efectivo' ? item.importe : 0), 0).toLocaleString(
                settings.numericLocales.language,
                settings.numericLocales.options
              )}
              sx={{ mt: 2, ml: 4, width: "15%" }}
              disabled
            />
            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, mt: 2, ml: 3 }}>
              Cantidad
            </Typography>
            <TextField
              name="cantidadEfectivo"
              size="small"
              inputProps={{ style: { textAlign: "center" } }}
              variant="outlined"
              value={cobranzas.reduce((acc, item) => acc + (item.tipo_cobro === 'efectivo' ? item.cantidad : 0), 0)}
              sx={{ mt: 2, ml: 2, width: "5%" }}
              disabled
            />

            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, ml: 2, mt: 2 }}>
              Total Otros
            </Typography>
            <TextField
              name="totalOtros"
              inputProps={{ style: { textAlign: "right" } }}
              size="small"
              variant="outlined"
              value={cobranzas.reduce((acc, item) => acc + (item.tipo_cobro !== 'efectivo' ? item.importe : 0), 0).toLocaleString(
                settings.numericLocales.language,
                settings.numericLocales.options
              )}
              sx={{ mt: 2, ml: 2, width: "15%" }}
              disabled
            />
            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, mt: 2, ml: 3 }}>
              Cantidad
            </Typography>
            <TextField

              name="cantidadOtros"
              size="small"
              inputProps={{ style: { textAlign: "center" } }}
              variant="outlined"
              value={cobranzas.reduce((acc, item) => acc + (item.tipo_cobro !== 'efectivo' ? item.cantidad : 0), 0)}
              sx={{ mt: 2, ml: 2, width: "5%" }}
              disabled
            />
          </Box>

          {/* table de Ajustes */}

          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6" display="block" gutterBottom sx={{ mr: 4 }}>
              Ajustes
            </Typography>
          </Grid>

          <DataGrid
            rows={ajustes}
            columns={tableAjustesColumns}
            {...tableOptions}
          />

          <Box sx={{ display: 'flex', alignItems: "center", ml: 3, mb: 3 }}>
            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, mt: 2 }}>
              Total Ajustes
            </Typography>
            <TextField
              name="totalAjustes"
              size="small"
              variant="outlined"
              inputProps={{ style: { textAlign: "right" } }}
              value={ajustes.reduce((acc, item) => acc + item.importe, 0).toLocaleString(
                settings.numericLocales.language,
                settings.numericLocales.options
              )}
              sx={{ mt: 2, ml: 4, width: "15%" }}
              disabled
            />

            {/* cantidad de ajuste */}
            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, mt: 2, ml: 3 }}>
              Cantidad
            </Typography>
            <TextField
              name="cantidadAjustes"
              size="small"
              inputProps={{ style: { textAlign: "center" } }}
              variant="outlined"
              value={ajustes.reduce((acc, item) => acc + item.cantidad, 0)}
              sx={{ mt: 2, ml: 2, width: "5%" }}
              disabled
            />
          </Box>

          {/* table de comprobantes de gastos */}

          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6" display="block" gutterBottom sx={{ mr: 4 }}>
              Comprobantes de Gastos
            </Typography>
          </Grid>

          <DataGrid
            rows={comprobantes}
            columns={tableComprobantesColumns}
            {...tableOptions}
          />

          <Box sx={{ display: 'flex', alignItems: "center", ml: 3, mb: 3 }}>
            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, mt: 2 }}>
              Total Gastos
            </Typography>

            <TextField
              name="totalComprobantes"
              size="small"
              inputProps={{ style: { textAlign: "right" } }}
              variant="outlined"
              value={comprobantes.reduce((acc, item) => acc + item.importe, 0).toLocaleString(
                settings.numericLocales.language,
                settings.numericLocales.options
              )}
              sx={{ mt: 2, ml: 4, width: "15%" }}
              disabled
            />
            {/* cantidad gastos */}
            <Typography component={"span"} variant={"body2"} sx={{ mr: 1, mt: 2, ml: 3 }}>
              Cantidad
            </Typography>
            <TextField
              name="cantidadComprobantes"
              size="small"
              inputProps={{ style: { textAlign: "center" } }}
              variant="outlined"
              value={comprobantes.reduce((acc, item) => acc + item.cantidad, 0)}
              sx={{ mt: 2, ml: 2, width: "5%" }}
              disabled
            />
          </Box>

          {/* control de efectivo */}

          <Typography variant="h6" display="block" gutterBottom sx={{ mr: 4 }}>
            Control de efectivo
          </Typography>
          {[
            { label: "Saldo al Inicio", value: control.saldo_apertura ? control.saldo_apertura : 0 },
            { label: "Efectivo en Caja", value: control.efectivo_caja ? control.efectivo_caja : 0 },
            { label: "Total Efectivo", value: control.total_efectivo ? control.total_efectivo : 0 },
            { label: "Total Ajustes", value: control.total_ajustes ? control.total_ajustes : 0 },
            { label: "Total Gastos", value: control.total_gastos ? control.total_gastos : 0 },
            { label: "Saldo Final", value: control.saldo_final ? control.saldo_final : 0 },
          ].map((item, index) => (
            <Box sx={{ display: 'flex', alignItems: "center", mt: 1, ml: 5 }} key={index}>
              <Typography
                component={"span"}
                variant={"body1"}
                sx={{
                  mr: 1,
                  minWidth: '120px',
                  color: item.label === "Saldo Final" ? (item.value < 0 ? 'red' : 'inherit') : 'inherit'
                }}
              >
                {item.label}
              </Typography>
              <TextField
                size="small"
                inputProps={{ style: { textAlign: "right" } }}
                variant="outlined"
                value={item.value < 0 ? `${Math.abs(item.value).toFixed(2)}` : Math.abs(item.value).toFixed(2)}
                sx={{
                  width: "150px",
                  ml: 1,
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: item.label === "Saldo Final" ? (item.value < 0 ? 'red' : 'inherit') : 'inherit'
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: item.label === "Saldo Final" ? (item.value < 0 ? 'red' : 'inherit') : 'inherit'
                    }
                  },
                  '& .MuiInputBase-input.Mui-disabled': {
                    WebkitTextFillColor: item.label === "Saldo Final" ? (item.value < 0 ? 'red' : 'inherit') : 'inherit'
                  }
                }}
                disabled
              />
            </Box>
          ))}

          <Box sx={{ display: 'flex', justifyContent: 'right' }}>
            <Grid item xs={12} md={2} lg={2}>
              <Button
                sx={{ mr: 4, width: "100%" }}
                variant="outlined"
                onClick={handleSalirRevisarCaja}
                startIcon={<CancelIcon />}
              >
                Cancelar
              </Button>
            </Grid>

            <Grid item xs={12} md={2} lg={2}>
              <Button
                sx={{ mr: 1, ml: 1, width: "100%" }}
                variant="contained"
                onClick={handleCerrarCaja}
                disabled={nonClose}
                startIcon={<DisabledByDefaultIcon />}
              >
                Cerrar Caja
              </Button>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }

      {/* agregar dialogo de confirmacion de cierre de caja  */}

      <Dialog
        open={openDialogCerrar}
        onClose={handleCloseDialogCerrar}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"¿Estás seguro que quierés Cerrar la Caja?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Esta acción cerrará DEFINITIVAMENTE la Caja
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => handleCloseDialogCerrar(true)}
            color="primary" autoFocus
            sx={{ mr: 1, mb: 1 }}
          >
            Sí, quiero cerrar la Caja
          </Button>
          <Button
            variant="outlined"
            onClick={() =>
              handleCloseDialogCerrar(false)}
            color="primary"
            sx={{ mr: 1, mb: 1 }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CajaCierreDialog;
